var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    {
      staticClass: "exemption-rate",
      attrs: { label: _vm.label, prop: _vm.prop, rules: _vm.rules }
    },
    [
      _c("el-input", {
        attrs: {
          type: "text",
          clearable: true,
          maxlength: 5,
          placeholder: _vm.placeholder,
          disabled: _vm.disabled,
          autofocus: _vm.autofocus
        },
        model: {
          value: _vm.exemptionRate,
          callback: function($$v) {
            _vm.exemptionRate = $$v
          },
          expression: "exemptionRate"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }